import { passCodes } from '../passCodes';
import track2 from '../../../../assets/audio/tracks/track2.mp3';

const hints = [
    {
        text: 'Cílové místo je v horní části náměstí.',
    },
    {
        text: 'Nachází se na rohu parkoviště a je zaděláno mříží.',
    },
    {
        text: 'Kódem je: studna',
        solution: true,
    },
];
export const step2dolphin = {
    id: 2,
    title: '1. stanoviště',
    taskText: `
        <p>
            Zdravím vás. Jmenuji se Míša, a moji majitelé mi občas říkají Miško, což podle mě není moc dobrý jméno pro kocoura, kdybych se k tomu mohl vyjádřit. Zní to moc jako myš, a to já přece nejsem!
        </p>
        <p>
            No ale o tom jsem ti říct nepřišel. Už nějakou dobu se potloukám po Žďáře a mám tu hodně známých, kteří mi vyprávějí o tom, co se tu všechno děje, abych měl přehled. Jako ono je to docela dost klidný město, takže většinou se jenom dozvím, jaká restaurace se tu nově otevřela nebo kdy jsou tu další farmářský trhy. Dneska ráno, když jsem ale tak vyrazil na svou běžnou obhlídku města, znáš to, vyplašit nějaké ty ptáky a zjistit co se tu děje, tak jsem tady na náměstí u Morového sloupu zaslechl volání.
        </p>
        <p>
            "Míšo, Míšo, pojď sem! To musíš slyšet!" Otočil jsem se ke svému známému, delfínovi, který už mnoho let sedí na hlavním náměstí a pozoruje vše, co se tu šustne. Bohužel to není opravdová ryba, to bych si jinak pochutnal. To mu ale neříkej, mám pocit, že by to nemuselo moc svědčit našemu kamarádství.
        </p>
        <p>
            "Představ si, dneska ráno tudy šli nějací lidé z radnice a taky muzea a bavili se o tom, že se něco ztratilo. Něco prý strašně moc důležitého. Myslím, že to bude nějaký průser, protože když se o tom bavili, tak šeptali. Šeptáš přece jenom když jde o něco tajného. Vůbec netuším, co by to mohlo být, ale určitě by tě neminula odměna, kdybys to objevil."
        </p>
        <p>
            Neskočíš to prozkoumat?                
        </p>
        <p>
            Pravda moc se mi nechtělo, ale zrovna dneska jsem se nudil a nějaká ta rybka nebo maso za odměnu by bodlo. "Kde mám začít?" řekl jsem. "Prvně mi pomoz dostat se do vody a tam třeba přijdeme na něco dalšího. Ale ne do kašny, jdi radši tam, kde budu krytý."
        </p>
    `,
    cipher: {
        text: 'Kam vás delfín posílá?',
        label: 'Úkol',
    },
    catImage: 1,
    taskPreviewText:
        'Zdravím vás. Jmenuji se Míša, a moji majitelé mi občas říkají Miško, což podle mě není moc dobrý jméno pro kocoura, kdybych se k tomu mohl vyjádřit. Zní to moc jako myš',
    audio: track2,
    snowAudio: track2,
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[0],
    additionalInfo: 'Odpovědí je jedno slovo na 6 písmen.',
    hints: hints,
    snowHints: hints,
};
